import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f659195"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "drawer_wrap" }
const _hoisted_2 = { class: "drawer_title" }
const _hoisted_3 = { class: "drawer_title_txt" }
const _hoisted_4 = { class: "drawer_form" }
const _hoisted_5 = { class: "drawer_form_input_wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "奖品名称：", -1))
const _hoisted_7 = { class: "dfiw_content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "drawer_form_desc" }, "上传说明：只支持.jpg格式，1：1比列，大小不能超过2M。", -1))
const _hoisted_9 = { class: "drawer_form_input_wrap" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "奖项名称：", -1))
const _hoisted_11 = { class: "dfiw_content" }
const _hoisted_12 = { class: "drawer_form_input_wrap" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "抽奖范围：", -1))
const _hoisted_14 = { class: "dfiw_content" }
const _hoisted_15 = { class: "dfiw_content_row_col" }
const _hoisted_16 = { class: "dfiw_content_row_col" }
const _hoisted_17 = { class: "dfiw_content_row" }
const _hoisted_18 = { class: "dfiw_content_row_col" }
const _hoisted_19 = { class: "dfiw_content_row_col" }
const _hoisted_20 = { class: "dfiw_content_row_col" }
const _hoisted_21 = { class: "dfiw_content_row_col" }
const _hoisted_22 = { class: "dfiw_content_row_col" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("参与用户必须打卡成功，才有几率中奖。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("(需要开启【注册观看】并且注册观看内需要有【手机号】收集来配合使用)。")
], -1))
const _hoisted_24 = { class: "drawer_form_input_wrap" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "截止时间：", -1))
const _hoisted_26 = { class: "dfiw_content" }
const _hoisted_27 = { class: "drawer_form_input_wrap" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title required" }, "中奖名额：", -1))
const _hoisted_29 = { class: "dfiw_content" }
const _hoisted_30 = { class: "drawer_form_input_wrap" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dfiw_title hide" }, "抽奖范围：", -1))
const _hoisted_32 = { class: "dfiw_content" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "过滤此直播间普通抽奖所有已中奖用户。", -1))
const _hoisted_34 = { class: "drawer_footer" }
const _hoisted_35 = { class: "btn_group" }
const _hoisted_36 = { key: 0 }

import { ref } from 'vue';
import { Checkbox, Input, Button, message, Popover, Upload, DatePicker, InputNumber } from 'ant-design-vue';
import { QuestionCircleFilled, UploadOutlined } from '@ant-design/icons-vue';
import CUpload from '@/components/CUpload.vue'; // 上传图片  组件
import LocalList from './LocalList.vue';
import AudienceList from './AudienceList.vue';
import FullList from './FullList.vue';
import WinningList from './WinningList.vue';
import http from '@/api';
import router from '@/router';
import { Applicant, ViewFormClass } from './lottery';
import { getToken } from '@/plugins/cookie';

interface FileItem {
  uid: string;
  name?: string;
  status?: string;
  response?: any;
  url?: string;
  type?: string;
  size: number;
  originFileObj: never;
}
interface FileInfo {
  file: FileItem;
  fileList: FileItem[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'CreateStandLogttery',
  props: {
    data: null
  },
  emits: ['click:callbackPage', 'click:back'],
  setup(__props: any, { emit }) {

const props = __props as {
  data: {
    applicants: Applicant;
    drawForm: ViewFormClass;
    id: number;
  };
};

const studioId = router.currentRoute.value.params.studioId;
const token = getToken();
const aCheckbox = Checkbox;
const aInput = Input;
const aButton = Button;
const aDatePicker = DatePicker;
const aPopover = Popover;
const aUpload = Upload;
const aInputNumber = InputNumber;


const onBlack = () => {
  emit('click:callbackPage');
};
const onBack = () => {
  emit('click:back');
};

// 获取 报名人数 该抽奖详情
const applicants = ref<Applicant>({
  fixed: 0, //内定名单 报名人数
  local: 0, // 本地名单 报名人数
  user: 0, // 观众参与 报名人数
});
const drawForm = ref<ViewFormClass>({
  autoDraw: false, // 自动开奖 0关 1开
  drawNo: '', //抽奖单号
  endAt: null,
  filter: false, //过滤中奖观众
  fixed: false, //内定中将
  id: 0,
  localJoin: false, // 本地名单
  numberWin: 0, //中奖人数
  pic: 0, // 图片id
  picUrl: '', //图片链接
  signJoin: false, //打卡
  status: 0, // 0关 1开 2已开奖 3已开奖且关闭
  title: '',
  userJoin: false, // 观众参与
  winHistory: false, //允许查看中奖历史
});
const getDrawWiew = () => {
  // const number = {
  //   studio_id: studioId,
  // };
  // http.lottery.getMemberNum({ params: number }).then((res) => {
  //   applicants.value = res.data.data;
  //   console.log('number', applicants.value);
  // });
  // // 有id 编辑 无新建
  // if (props.data.id) {
  //   const data = {
  //     id: props.data.id,
  //     studio_id: studioId,
  //   };
  //   http.lottery.getDrawWiew({ params: data }).then((res) => {
  //     drawForm.value = new ViewFormClass(res.data.data);
  //     console.log('props.data.id', props.data.id);
  //     console.log('data', drawForm.value);
  //   });
  // }
  applicants.value = props.data.applicants;
  drawForm.value = props.data.drawForm;
};
getDrawWiew();
const refresh = () => {
  const number = {
    studio_id: studioId,
  };
  http.lottery.getMemberNum({ params: number }).then((res) => {
    applicants.value = res.data.data;
  });
};
// 新建/编辑 保存
const createDraw = () => {
  const data = {
    studio_id: studioId,
    title: drawForm.value.title,
    pic: drawForm.value.pic,
    status: drawForm.value.status,
    user_join: drawForm.value.userJoin ? 1 : 0, //观众参与
    local_join: drawForm.value.localJoin ? 1 : 0, //本地名单
    fixed: drawForm.value.fixed ? 1 : 0, //内定名单
    sign_join: drawForm.value.signJoin ? 1 : 0, //打卡
    end_at: drawForm.value.endAt,
    auto_draw: drawForm.value.autoDraw ? 1 : 0, //到截止时间自动开奖
    number_win: drawForm.value.numberWin, //中奖名额
    filter: drawForm.value.filter ? 1 : 0, //过滤已中奖
    win_history: drawForm.value.winHistory ? 1 : 0, //允许观众查看历史中奖消息
    id: drawForm.value.id,
    switch: 0,
  };
  http.lottery
    .createDraw(data)
    .then((res) => {
      message.success(res.data.message);
      onBlack();
    })
    .catch((err) => {
      message.error(err.data.error);
    });
};
// 上传头像
const fileList = ref([]);
const pcUploadloading = ref(false);
const pcUploadImage = (info: FileInfo) => {
  if (info.file?.response?.code === 200) {
    drawForm.value.picUrl = info.file?.response?.data.url;
    drawForm.value.pic = info.file?.response?.data.id;
  }
  if (info.file.status === 'error') {
    message.error('上传失败');
  }
  if (info.file.status === 'uploading') {
    pcUploadloading.value = true;
  } else pcUploadloading.value = false;
};
const pcImageDel = () => {
  drawForm.value.picUrl = '';
  drawForm.value.pic = 0;
};
// 上传名单
const uploadList = (info: FileInfo) => {
  if (info.file.status === 'done') {
    if (info.file?.response?.code === 200) {
      message.success(info.file?.response?.message);
      refresh();
    } else if (info.file?.response?.code === 100) {
      message.error(info.file?.response?.error);
    }
  }
};
// 三级页面
const thirPage = ref(false);
const listType = ref(0);
const onOpenUserList = (index: number) => {
  thirPage.value = true;
  listType.value = index;
};
const callbackSecPage = () => {
  refresh();
  thirPage.value = false;
  listType.value = 0;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _withDirectives(_createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(props.data.id ? (drawForm.value.status > 1 ? '抽奖详情' : '编辑抽奖') : '新建抽奖'), 1),
        (drawForm.value.status > 1)
          ? (_openBlock(), _createBlock(_unref(aButton), {
              key: 0,
              type: "link",
              class: "drawer_title_back",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (onOpenUserList(0)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("中奖名单")
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_unref(aButton), {
              key: 1,
              type: "link",
              class: "drawer_title_back",
              onClick: onBack
            }, {
              default: _withCtx(() => [
                _createTextVNode("返回>>")
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(CUpload, {
              "file-list": fileList.value,
              "image-name": drawForm.value.picUrl,
              loading: pcUploadloading.value,
              "handle-change": (info) => pcUploadImage(info),
              "click-stop": pcImageDel,
              class: "dfiw_conten_pcload"
            }, null, 8, ["file-list", "image-name", "loading", "handle-change"])
          ])
        ]),
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_unref(aInput), {
              value: drawForm.value.title,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((drawForm.value.title) = $event)),
              class: "dicf_item_input"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: drawForm.value.localJoin }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: drawForm.value.localJoin,
                "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((drawForm.value.localJoin) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("本地名单")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createElementVNode("div", _hoisted_15, "报名人数：" + _toDisplayString(applicants.value.local) + "人", 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "dfiw_content_row_btn",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (onOpenUserList(1)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("本地名单")
                  ]),
                  _: 1
                })
              ])
            ], 2),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(aUpload), {
                "file-list": fileList.value,
                "onUpdate:fileList": _cache[4] || (_cache[4] = ($event: any) => ((fileList).value = $event)),
                name: "file",
                multiple: true,
                action: "/api/v1/draw/upload_local",
                headers: { token: _unref(token) },
                data: () => ({ studio_id: _unref(studioId) }),
                "show-upload-list": false,
                onChange: uploadList,
                accept: ".xls,.xlsx,.csv"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(aButton), { class: "dfiw_content_row_upload mod_modal_btn" }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(UploadOutlined)),
                      _createTextVNode("上传名单")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "headers", "data"]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "dfiw_content_row_btn",
                  href: "https://static.lighos.com/default/lottery.xlsx"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("下载模版")
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: drawForm.value.userJoin }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: drawForm.value.userJoin,
                "onUpdate:checked": _cache[5] || (_cache[5] = ($event: any) => ((drawForm.value.userJoin) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("观众参与")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createElementVNode("div", _hoisted_19, "报名人数：" + _toDisplayString(applicants.value.user) + "人", 1),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "dfiw_content_row_btn",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (onOpenUserList(2)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("观众参与名单")
                  ]),
                  _: 1
                })
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: drawForm.value.fixed }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: drawForm.value.fixed,
                "onUpdate:checked": _cache[7] || (_cache[7] = ($event: any) => ((drawForm.value.fixed) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("内定名单")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createElementVNode("div", _hoisted_21, "报名人数：" + _toDisplayString(applicants.value.fixed) + "人", 1),
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_unref(aButton), {
                  type: "link",
                  class: "dfiw_content_row_btn",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (onOpenUserList(3)))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("全部名单")
                  ]),
                  _: 1
                })
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: drawForm.value.signJoin }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: drawForm.value.signJoin,
                "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((drawForm.value.signJoin) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("打卡参与")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_unref(aPopover), null, {
                content: _withCtx(() => [
                  _hoisted_23
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "tips" })
                ]),
                _: 1
              })
            ], 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_unref(aDatePicker), {
              class: "dicf_item_input",
              "show-time": "",
              placeholder: "请选择日期时间",
              value: drawForm.value.endAt,
              "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((drawForm.value.endAt) = $event))
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            _createVNode(_unref(aInputNumber), {
              value: drawForm.value.numberWin,
              "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((drawForm.value.numberWin) = $event)),
              min: 0,
              class: "dicf_item_input"
            }, null, 8, ["value"])
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _hoisted_31,
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: drawForm.value.filter }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: drawForm.value.filter,
                "onUpdate:checked": _cache[12] || (_cache[12] = ($event: any) => ((drawForm.value.filter) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("过滤已中奖观众")
                ]),
                _: 1
              }, 8, ["checked"]),
              _createVNode(_unref(aPopover), { placement: "right" }, {
                content: _withCtx(() => [
                  _hoisted_33
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(QuestionCircleFilled), { class: "tips" })
                ]),
                _: 1
              })
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: drawForm.value.autoDraw }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: drawForm.value.autoDraw,
                "onUpdate:checked": _cache[13] || (_cache[13] = ($event: any) => ((drawForm.value.autoDraw) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("到截止时间自动开奖")
                ]),
                _: 1
              }, 8, ["checked"])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["dfiw_content_row", { checked: drawForm.value.winHistory }])
            }, [
              _createVNode(_unref(aCheckbox), {
                checked: drawForm.value.winHistory,
                "onUpdate:checked": _cache[14] || (_cache[14] = ($event: any) => ((drawForm.value.winHistory) = $event)),
                class: "dfiw_content_row_checkbox"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("允许观众查看历史中奖消息")
                ]),
                _: 1
              }, 8, ["checked"])
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_unref(aButton), {
            class: "mod_modal_btn",
            onClick: onBack
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          (drawForm.value.status < 2)
            ? (_openBlock(), _createBlock(_unref(aButton), {
                key: 0,
                class: "mod_modal_btn mod_type_primary",
                onClick: createDraw
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确定")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ], 512), [
      [_vShow, !thirPage.value]
    ]),
    (thirPage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
          (listType.value === 1)
            ? (_openBlock(), _createBlock(LocalList, {
                key: 0,
                "data-source": {
          drawType: 1,
        },
                "onClick:callbackSecPage": callbackSecPage
              }))
            : _createCommentVNode("", true),
          (listType.value === 2)
            ? (_openBlock(), _createBlock(AudienceList, {
                key: 1,
                "data-source": {
          drawType: 1,
        },
                "onClick:callbackSecPage": callbackSecPage
              }))
            : _createCommentVNode("", true),
          (listType.value === 3)
            ? (_openBlock(), _createBlock(FullList, {
                key: 2,
                "data-source": {
          drawType: 1,
        },
                "onClick:callbackSecPage": callbackSecPage
              }))
            : _createCommentVNode("", true),
          (listType.value === 0)
            ? (_openBlock(), _createBlock(WinningList, {
                key: 3,
                "data-source": {
          drawType: 1,
        },
                "onClick:callbackWinPage": callbackSecPage,
                "data-draw": { draw_no: drawForm.value.drawNo }
              }, null, 8, ["data-draw"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})